module.exports = __webpack_public_path__ + "static/media/something.b41338ae.png";